/* eslint-disable */
import { Enrollment } from "../../../@types/enrollment.types";
import { Member } from "../../../@types/member.types";
import { CoverageType } from "../../../@types/plan.types";
import { RELATIONSHIP } from "../../../constants/relationships";
import { enrollment } from "../../api/enrollment/enrollment";
import { calculateAge } from "../age";

export const getCoveredDependents = (coverage: CoverageType): string[] => {
	const coveredDependents: string[] = [];
	if (coverage.ES.active === true) {
		coveredDependents.push(RELATIONSHIP.spouse);
	}
	if (coverage.EC.active === true) {
		coveredDependents.push(RELATIONSHIP.child);
		coveredDependents.push(RELATIONSHIP.disabled_child);
		coveredDependents.push(RELATIONSHIP.stepchild);
		coveredDependents.push(RELATIONSHIP.court_ordered_dependent);
	}
	return coveredDependents;
};

export const fullDate = new Date().getFullYear() + "-" + new Date().getMonth() + "-" + new Date().getDate();

export const getHealthPlanEligibleDependents = (dependents: Member[], coverage: CoverageType): Member[] => {
	const coveredDependents = getCoveredDependents(coverage);

	const eligibleDependents: Member[] = [];

	dependents.forEach((dependent: Member) => {
		const { relationship, date_of_birth, is_disabled, dependent_type } = dependent;

		const age = calculateAge(date_of_birth, fullDate);
		if (
			dependent_type !== "Not Eligible" &&
			((relationship !== "SPOUSE" &&
				coveredDependents.includes(relationship as string) &&
				(age < 26 || (age >= 26 && is_disabled === true))) ||
				relationship === "SPOUSE")
		) {
			eligibleDependents.push(dependent);
		}
	});

	return eligibleDependents;
};

export const getClinicCardEligibleDependents = (dependents: Member[], coverage: CoverageType): Member[] => {
	const coveredDependents = [
		RELATIONSHIP.spouse,
		RELATIONSHIP.child,
		RELATIONSHIP.disabled_child,
		RELATIONSHIP.stepchild,
		RELATIONSHIP.court_ordered_dependent
	];

	const eligibleDependents: Member[] = [];
	dependents.forEach((dependent: Member) => {
		const { relationship, date_of_birth, is_disabled, dependent_type } = dependent;
		const age = calculateAge(date_of_birth, new Date());
		if (
			dependent_type !== "Not Eligible" &&
			((relationship !== "SPOUSE" &&
				coveredDependents.includes(relationship as string) &&
				((age < 26 && age >= 8) || (age >= 26 && is_disabled === true))) ||
				relationship === "SPOUSE")
		) {
			eligibleDependents.push(dependent);
		}
	});

	return eligibleDependents;
};

export const getEnrollmentsByCoverage = (
	enrollments: Enrollment[]
): {
	coveredSpouseEnrollment: Enrollment | null;
	employeeEnrollment: Enrollment | null;
	coveredChildrenEnrollments: Enrollment[];
} => {
	let employeeEnrollment: Enrollment | null = null;
	let coveredSpouseEnrollment: Enrollment | null = null;
	const coveredChildrenEnrollments: Enrollment[] = [];
	// console.log("getEnrollmentsByCoverage", enrollments);
	enrollments.forEach((enrollment: Enrollment) => {
		const { member } = enrollment;
		if (member?.relationship === RELATIONSHIP.spouse) {
			coveredSpouseEnrollment = enrollment;
		} else if (enrollment.member_SSN === enrollment.insured_SSN) {
			employeeEnrollment = enrollment;
		} else {
			coveredChildrenEnrollments.push(enrollment);
		}
	});
	// console.log("employeeEnrollment", employeeEnrollment);
	return {
		coveredChildrenEnrollments,
		coveredSpouseEnrollment,
		employeeEnrollment
	};
};

export const getCurrentActivePlanEligibleDependents = (dependents: Member[], coverage: CoverageType): Member[] => {
	const coveredDependents = getCoveredDependents(coverage);

	const eligibleDependents: Member[] = [];

	dependents.forEach((dependent: Member) => {
		const { relationship, date_of_birth, is_disabled, dependent_type } = dependent;

		const age = calculateAge(date_of_birth, fullDate);
		if (
			dependent_type !== "Not Eligible" &&
			((relationship !== "SPOUSE" &&
				coveredDependents.includes(relationship as string) &&
				(age < 26 || (age >= 26 && is_disabled === true))) ||
				relationship === "SPOUSE")
		) {
			eligibleDependents.push(dependent);
		}
	});

	return eligibleDependents;
};

const resolveCoverageCode = (coverageCode: string, coverage: CoverageType): string | null => {
	// exact coverage active
	if ((coverage as any)?.[coverageCode]?.active) {
		return coverageCode;
	}

	if (coverageCode === "EC" && (coverage as any)?.ECH?.active) {
		return "ECH";
	}

	if ((coverage as any)?.ED?.active) {
		return "ED";
	}

	return null;
};

//OLD CODE
// export const getEligibleDependentsOfPlan = (
// 	dependents: Member[],
// 	coverage: CoverageType,
// 	dependent_eligibility_input: any = []
// ): any => {
// 	// The plan schema stores dependent_eligibility with `default: null`, and a default
// 	// parameter only fills in for `undefined` — so null slipped through and `.find()` threw.
// 	// Normalise to an array once, here, covering every use below.
// 	const dependent_eligibility: any[] = Array.isArray(dependent_eligibility_input) ? dependent_eligibility_input : [];
// 	// const coveredDependents = getCoveredDependents(coverage);
// 	// console.log("Covered Depednets", coveredDependents);

// 	// console.log(dependent_eligibility, "dependent_eligibility", coverage, "test", dependents);

// 	const eligibleDependents: Member[] = [];
// 	const ineligibleDependents: Member[] = [];
// 	const ineligibleRelationshipDependents: Member[] = [];
// 	const coverageCodeForRelationship: any = {
// 		spouse: "ES",
// 		child: "EC",
// 		children: "ECH",
// 		dependent: "ED"
// 	};
// 	let dependentEligibilityRelationshipTypeFound: any = null;
// 	// let dependentEligible = false;
// 	dependents.forEach((dependent: Member) => {
// 		const { relationship, date_of_birth, is_disabled, dependent_type } = dependent;
// 		// const otherDate = new Date("2023-05-01");

// 		if (
// 			relationship?.trim().toLowerCase().replace(/-/g, " ") === "grand child" ||
// 			relationship?.trim().toLowerCase() === "grandchild"
// 		) {
// 			ineligibleDependents.push(dependent);
// 			return;
// 		}
// 		const fullDate = new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate();
// 		const age = calculateAge(date_of_birth, fullDate);
// 		// console.log(dependent, "Age", age);
// 		if (relationship) {
// 			// const relation=relationship.toLowerCase().includes("children")
// 			let covergageCode: any = coverageCodeForRelationship[relationship.toLowerCase()];
// 			const relation = relationship.toLowerCase().includes("children")
// 				? "children"
// 				: relationship.toLowerCase().includes("child")
// 				? "child"
// 				: relationship.toLowerCase();

// 			if (!covergageCode) {
// 				covergageCode = coverageCodeForRelationship[relation as keyof typeof coverageCodeForRelationship];
// 			}
// 			// console.log(dependent_eligibility, "testtt1 7", relationship, covergageCode, relation);
// 			// dependentEligibilityRelationshipTypeFound =
// 			// 	dependent_eligibility.find(
// 			// 		(eligible_dependent: any) => eligible_dependent.relationship_type.toLowerCase() == "dependent"
// 			// 	) || null;
// 			// if (!dependentEligibilityRelationshipTypeFound) {
// 			// 	dependentEligibilityRelationshipTypeFound = dependent_eligibility.find(
// 			// 		(eligible_dependent: any) =>
// 			// 			eligible_dependent.relationship_type.toLowerCase() == relationship.toLowerCase() ||
// 			// 			eligible_dependent.relationship_type.toLowerCase() == relation
// 			// 	);

// 			// 	// console.log(
// 			// 	// 	date_of_birth,
// 			// 	// 	fullDate,
// 			// 	// 	"testtt1 8",
// 			// 	// 	dependentEligibilityRelationshipTypeFound,
// 			// 	// 	(coverage as any)[covergageCode]?.active
// 			// 	// );
// 			// } else {
// 			// 	covergageCode = "ED";
// 			// }

// 			// // if (found) {
// 			// // 	dependentEligible = true;
// 			// // }
// 			// // console.log(
// 			// // 	dependent_eligibility,
// 			// // 	"dekhlo",
// 			// // 	dependentEligibilityRelationshipTypeFound,
// 			// // 	dependent,
// 			// // 	covergageCode,
// 			// // 	coverage
// 			// // );
// 			// if (dependentEligibilityRelationshipTypeFound && (coverage as any)[covergageCode]?.active) {
// 			// 	if (
// 			// 		(dependentEligibilityRelationshipTypeFound.min_age <= age &&
// 			// 			dependentEligibilityRelationshipTypeFound.max_age > age &&
// 			// 			dependent_type != "Not Eligible") ||
// 			// 		(is_disabled == true && dependent_type != "Not Eligible")
// 			// 	) {
// 			// 		// console.log("testttt1 9", dependent);
// 			// 		eligibleDependents.push(dependent);
// 			// 	} else {
// 			// 		// console.log("testttt1 90", dependent);
// 			// 		ineligibleDependents.push(dependent);
// 			// 	}
// 			// } else {
// 			// 	// console.log("testttt1 94", dependent);
// 			// 	ineligibleRelationshipDependents.push(dependent);
// 			// }
// 			dependentEligibilityRelationshipTypeFound =
// 				dependent_eligibility.find(
// 					(eligible_dependent: any) => eligible_dependent.relationship_type.toLowerCase() == relation
// 				) || null;

// 			const resolvedCoverageCode = resolveCoverageCode(covergageCode, coverage);

// 			if (dependentEligibilityRelationshipTypeFound && resolvedCoverageCode) {
// 				if (
// 					(dependentEligibilityRelationshipTypeFound.min_age <= age &&
// 						dependentEligibilityRelationshipTypeFound.max_age > age &&
// 						dependent_type != "Not Eligible") ||
// 					(is_disabled == true && dependent_type != "Not Eligible")
// 				) {
// 					// console.log("testttt1 9", dependent);
// 					eligibleDependents.push(dependent);
// 				} else {
// 					// console.log("testttt1 90", dependent);
// 					ineligibleDependents.push(dependent);
// 				}
// 			} else {
// 				// console.log("testttt1 94", dependent);
// 				ineligibleRelationshipDependents.push(dependent);
// 			}
// 		}
// 	});

// 	// return {
// 	// 	eligibleDependents,
// 	// 	ineligibleDependents,
// 	// 	ineligibleRelationshipDependents
// 	// };
// 	return eligibleDependents;

// 	// return dependentEligible
// 	// 	? {
// 	// 			eligibleDependents,
// 	// 			ineligibleDependents,
// 	// 			ineligibleRelationshipDependents
// 	// 	  }
// 	// 	: {
// 	// 			eligibleDependents: [],
// 	// 			ineligibleDependents: [],
// 	// 			ineligibleRelationshipDependents: []
// 	// 	  };
// };

const normalizeRelationship = (relationship: string) => {
	const relation = relationship.trim().toLowerCase().replace(/-/g, " ");

	if (relation === "step child") return "child";
	if (relation === "court ordered dependent") return "child";
	if (relation === "legal custody child") return "child";
	// if (relation === "grandchild") return "child";

	return relation;
};

export const getEligibleDependentsOfPlan = (
	dependents: Member[],
	coverage: CoverageType,
	dependent_eligibility: any = []
): any => {
	// const coveredDependents = getCoveredDependents(coverage);
	// console.log("Covered Depednets", coveredDependents);

	// console.log(dependent_eligibility, "dependent_eligibility");
	// console.log("eligiblityDialogProps======>", dependents, coverage, dependent_eligibility);

	const eligibleDependents: Member[] = [];
	const ineligibleDependents: Member[] = [];
	const ineligibleRelationshipDependents: Member[] = [];
	const coverageCodeForRelationship: any = {
		spouse: "ES",
		child: "EC",
		children: "ECH",
		dependent: "ED"
	};
	let dependentEligibilityRelationshipTypeFound: any = null;
	// let dependentEligible = false;
	dependents.forEach((dependent: Member) => {
		const { relationship, date_of_birth, is_disabled, dependent_type } = dependent;
		// const otherDate = new Date("2023-05-01");

		if (
			relationship?.trim().toLowerCase().replace(/-/g, " ") === "grand child" ||
			relationship?.trim().toLowerCase() === "grandchild"
		) {
			ineligibleDependents.push(dependent);
			return;
		}

		const age = calculateAge(date_of_birth, fullDate);
		// console.log(dependent, "Age", age);
		// console.log("eligiblityDialogProps======> 222", relationship, date_of_birth, is_disabled, dependent_type);
		// console.log("debug=====> 3333", relationship, date_of_birth, is_disabled, dependent_type);
		if (relationship) {
			// const relation=relationship.toLowerCase().includes("children")
			// let covergageCode: any = coverageCodeForRelationship[relationship.toLowerCase()];
			const normalizedRelationship = normalizeRelationship(relationship);

			const covergageCode: any = coverageCodeForRelationship[normalizedRelationship];
			// console.log("debug=====> 4444", covergageCode, normalizedRelationship);

			// dependentEligibilityRelationshipTypeFound =
			// 	dependent_eligibility.find(
			// 		(eligible_dependent: any) => eligible_dependent.relationship_type.toLowerCase() == "dependent"
			// 	) || null;
			// if (!dependentEligibilityRelationshipTypeFound) {
			// dependentEligibilityRelationshipTypeFound = dependent_eligibility.find(
			// 	(eligible_dependent: any) =>
			// 		eligible_dependent.relationship_type.toLowerCase() == relationship.toLowerCase()
			// );
			dependentEligibilityRelationshipTypeFound = dependent_eligibility.find(
				(eligible_dependent: any) =>
					eligible_dependent.relationship_type.toLowerCase() === normalizedRelationship
			);

			if (!dependentEligibilityRelationshipTypeFound && coverage?.ED?.active) {
				dependentEligibilityRelationshipTypeFound =
					dependent_eligibility.find((item: any) => item.relationship_type.toLowerCase() === "dependent") ||
					null;
			}
			// } else { 464-65-3747
			// 	covergageCode = "ED";
			// }

			const resolvedCoverageCode = resolveCoverageCode(covergageCode, coverage);

			if (dependentEligibilityRelationshipTypeFound && resolvedCoverageCode) {
				const isClinicCardDependent =
					dependentEligibilityRelationshipTypeFound.relationship_type &&
					(normalizedRelationship?.trim().toLowerCase().includes("child") ||
						normalizedRelationship === "court-ordered dependent");

				const maxAge = isClinicCardDependent ? 26 : dependentEligibilityRelationshipTypeFound.max_age;
				if (
					(dependentEligibilityRelationshipTypeFound.min_age <= age &&
						// dependentEligibilityRelationshipTypeFound.max_age > age &&
						maxAge > age &&
						dependent_type != "Not Eligible") ||
					(is_disabled == true && dependent_type != "Not Eligible")
				) {
					eligibleDependents.push(dependent);
				} else {
					ineligibleDependents.push(dependent);
				}
			} else {
				ineligibleRelationshipDependents.push(dependent);
			}
		}
	});
	// return {
	// 	eligibleDependents,
	// 	ineligibleDependents,
	// 	ineligibleRelationshipDependents
	// };

	return eligibleDependents;
	// 	? {
	// 			eligibleDependents,
	// 			ineligibleDependents,
	// 			ineligibleRelationshipDependents
	// 	  }
	// 	: {
	// 			eligibleDependents: [],
	// 			ineligibleDependents: [],
	// 			ineligibleRelationshipDependents: []
	// 	  };
};
